import VacancyFillFactory from './VacancyFillFactory.component';

export default VacancyFillFactory;
